import React from 'react';

const SingleTick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18px"
      height="18px"
      viewBox="0 0 16 16"
      version="1.1"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <polyline points="2.75 8.75,6.25 12.25,13.25 4.75" />
    </svg>
  );
};

export default SingleTick;
